// Module
var code = "<div class=\"access-log\"><h3 class=\"profile-section-title-static first-one\">Recent Activity</h3><ul><li ng-repeat=\"item in activity track by item.id\"><time>{{item.formatted_created_at}} </time>{{item.message}}</li></ul></div>\n";
// Exports
module.exports = code;